export const DEFAULT_MAX_CLIP_MINUTES = 20;
export const MATCH_TYPES = [
  { id: "domestic", label: "Domestic" },
  { id: "international", label: "International" },
];

function isPlainObject(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

// Companies created before the domestic/international split stored a single
// flat number. Fall back to applying that legacy value to both buckets so
// existing configured limits/max-clip-lengths aren't silently reset.
export function getLimitMinutes(company, matchType) {
  if (!company) return null;
  const nested = company.downloadLimitMinutes;
  if (isPlainObject(nested)) {
    const value = nested[matchType];
    return value === undefined ? null : value;
  }
  if (nested === null || nested === undefined || nested === "") return null;
  return Number(nested);
}

export function getUsedMinutes(company, matchType) {
  if (!company) return 0;
  const nested = company.downloadUsedMinutes;
  if (isPlainObject(nested)) {
    return Number(nested[matchType]) || 0;
  }
  return 0;
}

export function getMaxClipMinutes(company, matchType) {
  if (!company) return DEFAULT_MAX_CLIP_MINUTES;
  const nested = company.maxClipMinutes;
  if (isPlainObject(nested)) {
    const value = Number(nested[matchType]);
    return Number.isFinite(value) && value > 0 ? value : DEFAULT_MAX_CLIP_MINUTES;
  }
  const value = Number(nested);
  return Number.isFinite(value) && value > 0 ? value : DEFAULT_MAX_CLIP_MINUTES;
}

export function getUserUsage(company, userId, matchType) {
  if (!company || !userId) return 0;
  const usage = company.usersUsage && company.usersUsage[userId];
  if (isPlainObject(usage)) {
    return Number(usage[matchType]) || 0;
  }
  return 0;
}

export function formatMinutes(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "0";
  return n.toFixed(n % 1 === 0 ? 0 : 1);
}

export function formatLimit(value) {
  if (value === null || value === undefined || value === "") return "Unlimited";
  return formatMinutes(value);
}

export function getRemainingMinutes(company, matchType) {
  const limit = getLimitMinutes(company, matchType);
  if (limit === null || limit === undefined) return null; // unlimited
  const used = getUsedMinutes(company, matchType);
  return Math.max(0, Number(limit) - used);
}
